import { render, staticRenderFns } from "./CASEFrameworkViewer.vue?vue&type=template&id=08ff14df"
import script from "./CASEFrameworkViewer.vue?vue&type=script&lang=js"
export * from "./CASEFrameworkViewer.vue?vue&type=script&lang=js"
import style0 from "./CASEFrameworkViewer.vue?vue&type=style&index=0&id=08ff14df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports